<template>
	<div>
		<base-header class="pb-6 bg-light">
			<b-row aling-v="center" class="py-4">
				<b-col cols="7" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Home</h6>
				</b-col>
				<b-col cols="5" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>

			<b-row>
				<!--Data Sessions-->
				<b-col xl="3" lg="6" md="6">
					<statistics
						title="Data Sessions"
						cTitle="Current"
						dTitle="Daily"
						mTitle="Monthly"
						yTitle="Yearly"
						tabId="dataSession"
						type="gradient-info"
						color="bg-gradient-info"
						icon="fa fa-question"
						:tooltip="dataSessionToolTip"
						@changeSessionTab="changeSessionTab($event)"
						border="1"
					>
						<template slot="footer">
							<div class="text-center">
								<b-icon
									icon="three-dots"
									class="text-center"
									animation="cylon"
									font-scale="4"
									v-if="!totalDataSessionValue && !dataSessionFailedStatus"
								></b-icon>
							</div>
							<span v-if="totalDataSessionValue">
								<span class="h1 text-white font-weight-900 mb-0">{{ totalDataSessionValue }}</span>
								<br /><br />
								<span class="h3 text-white">Total Data Sessions</span>
								<span class="h4 text-white mr-2 float-right">{{ totalDataSessionPercent }}</span>
							</span>
							<div v-if="dataSessionFailedStatus" class="text-center mt-2">
								<i class="fas fa-exclamation-triangle text-yellow" aria-hidden="true"></i><br />
								<span class="ml-2 mr-2 h4 text-white"
									>We were unable to load your data. Please contact support if you need assistance
									with this error.</span
								>
							</div>
						</template>
					</statistics>
				</b-col>

				<!--Data Volume-->
				<b-col xl="3" lg="6" md="6">
					<statistics
						title="Data Volume"
						cTitle="Current"
						dTitle="Daily"
						mTitle="Monthly"
						yTitle="Yearly"
						type="gradient-info"
						tabId="dataVolume"
						color="bg-gradient-success"
						icon="fa fa-question"
						:tooltip="dataVolumeToolTip"
						@changeVolumeTab="changeVolumeTab($event)"
					>
						<template slot="footer">
							<div class="text-center">
								<b-icon
									icon="three-dots"
									class="text-center"
									animation="cylon"
									font-scale="4"
									v-if="!totalDataVolumeValue && !dataVolumeFailedStatus"
								></b-icon>
							</div>
							<span v-if="totalDataVolumeValue">
								<span class="h1 text-white font-weight-900 mb-0">{{ totalDataVolumeValue }}</span>
								<br /><br />
								<span class="h3 text-white">Total Data Volume</span>
								<span class="h4 text-white mr-2 float-right">{{ totalDataVolumePercent }}</span>
							</span>
							<div v-if="dataVolumeFailedStatus" class="text-center mt-2">
								<i class="fas fa-exclamation-triangle text-yellow" aria-hidden="true"></i><br />
								<span class="ml-2 mr-2 h4 text-white"
									>We were unable to load your data. Please contact support if you need assistance
									with this error.</span
								>
							</div>
						</template>
					</statistics>
				</b-col>
				<!--Alerts-->
				<b-col xl="3" lg="6" md="6">
					<statistics
						title="Alerts"
						nonTitle="Session"
						cTitle="Current"
						dTitle="Daily"
						mTitle="Monthly"
						yTitle="Yearly"
						type="gradient-info"
						tabId="alerts"
						color="bg-gradient-warning"
						icon="fa fa-question"
						:tooltip="alertsToolTip"
						@changeAlertsTab="changeAlertsTab($event)"
					>
						<template slot="footer">
							<div class="text-center">
								<b-icon
									icon="three-dots"
									class="text-center"
									animation="cylon"
									font-scale="4"
									v-if="!totalAlertsValue && !alertsFailedStatus"
								></b-icon>
							</div>
							<span v-if="totalAlertsValue">
								<span class="h1 text-white font-weight-900 mb-0">{{ totalAlertsValue }}</span>
								<br /><br />
								<span class="h3 text-white">Total Alerts</span>
								<span class="h4 text-white mr-2 float-right">{{ totalAlertsPercent }}</span>
							</span>
							<div v-if="alertsFailedStatus" class="text-center mt-2">
								<i class="fas fa-exclamation-triangle text-yellow" aria-hidden="true"></i><br />
								<span class="ml-2 mr-2 h4 text-white"
									>We were unable to load your data. Please contact support if you need assistance
									with this error.</span
								>
							</div>
						</template>
					</statistics>
				</b-col>
				<!--Zero Session-->
				<b-col xl="3" lg="6" md="6">
					<statistics
						title="Zero Sessions"
						cTitle="Current"
						dTitle="Daily"
						mTitle="Monthly"
						yTitle="Yearly"
						type="gradient-info"
						tabId="zeroSessions"
						color="bg-gradient-danger"
						icon="fa fa-question"
						:tooltip="zeroSessionsToolTip"
						@changeZeroSessionsTab="changeZeroSessionsTab($event)"
					>
						<template slot="footer">
							<div class="text-center">
								<b-icon
									icon="three-dots"
									class="text-center"
									animation="cylon"
									font-scale="4"
									v-if="!totalZeroSessionValue && !zeroSessionsFailedStatus"
								></b-icon>
							</div>
							<span v-if="totalZeroSessionValue">
								<span class="h1 text-white font-weight-900 mb-0">{{ totalZeroSessionValue }}</span>
								<br /><br />
								<span class="h3 text-white">Total Zero Sessions</span>
								<span class="h4 text-white mr-2 float-right">{{ totalZeroSessionPercent }}</span>
							</span>
							<div v-if="zeroSessionsFailedStatus" class="text-center mt-2">
								<i class="fas fa-exclamation-triangle text-yellow" aria-hidden="true"></i><br />
								<span class="ml-2 mr-2 h4 text-white"
									>We were unable to load your data. Please contact support if you need assistance
									with this error.</span
								>
							</div>
						</template>
					</statistics>
				</b-col>
			</b-row>
		</base-header>

		<b-container fluid class="mt--6">
			<b-row>
				<b-col xl="8">
					<data-volume-trend
						title="Data Volume Trends by Period"
						cTitle="Current"
						dTitle="Daily"
						mTitle="Monthly"
						yTitle="Yearly"
						type="gradient-info"
						icon="fa fa-question"
						:tooltip="dataVolumeByPeriodToolTip"
						@graphChangeTab="graphChangeTab($event)"
					>
					</data-volume-trend>

					<data-volume-by-region
						title="Data Volume Trends by Region"
						cTitle="Current"
						dTitle="Daily"
						mTitle="Monthly"
						yTitle="Yearly"
						type="gradient-info"
						icon="fa fa-question"
						:tooltip="dataVolumeByRegionToolTip"
						@changeDataRegionTab="getDataRegionChangeTab($event)"
					></data-volume-by-region>
				</b-col>

				<b-col xl="4">
					<top-metrics
						title="Top Metrics ( Current )"
						volumeT="Data Volume"
						sessionT="Data Sessions"
						alertT="Alerts"
						zeroT="Zero Session"
						type="gradient-info"
						icon="fa fa-question"
						:tooltip="topMetricsDataVolumeToolTip"
						@changeTopMetricTab="getTopMetricsFunc($event)"
					></top-metrics>

					<sim-inventory
						title="SIM Inventory"
						icon="fa fa-question"
						type="gradient-info"
						:tooltip="simInventoryToolTip"
					></sim-inventory>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import RouteBreadCrumb from "../../../components/Breadcrumb/RouteBreadcrumb";
import Statistics from "./Statistics";
import DataVolumeTrend from "./DataVolumeTrendsByPeriod";
import TopMetrics from "./TopMetrics";
import HomeDashboardService from "@/common/api-services/home-dashboard-service";
import DataVolumeByRegion from "./DataVolumeByRegion";
import SimInventory from "./SimInventory";
import cardOpenStatusDirective from "../../../common/directive/card-open-status-directive";
import configDirective from "../../../common/directive/config-directive";

export default {
	components: {
		SimInventory,
		DataVolumeByRegion,
		RouteBreadCrumb,
		Statistics,
		DataVolumeTrend,
		TopMetrics,
	},
	data() {
		return {
			totalDataSessionValue: null,
			totalDataSessionPercent: null,
			totalDataVolumeValue: null,
			totalDataVolumePercent: null,
			totalAlertsValue: null,
			totalAlertsPercent: null,
			totalZeroSessionValue: null,
			totalZeroSessionPercent: null,
			chartXLabel: [],
			chartDataVolume: [],
			dataSessionToolTip: null,
			dataVolumeToolTip: null,
			alertsToolTip: null,
			zeroSessionsToolTip: null,
			dataVolumeByPeriodToolTip: null,
			dataVolumeByRegionToolTip: null,
			topMetricsDataVolumeToolTip: null,
			watchDogAlertsToolTip: null,
			simInventoryToolTip: null,
			dataVolumeTrendsByPeriodData: [],
			dataSessionFailedStatus: false,
			dataVolumeFailedStatus: false,
			alertsFailedStatus: false,
			zeroSessionsFailedStatus: false,
		};
	},
	mounted() {
		document.title = "Home"; // this.properCase(process.env.VUE_APP_CLIENT) + " Provisioning Portal";// - " + this.name;
		this.getDataSessions("current");
		this.getDataVolume("current");
		this.getAlerts("current");
		this.getZeroSessions("current");
		this.graphChangeTab("current");
		this.getDataVolumeAverages();
		this.getTopMetricsFunc("DataVolume");
		this.getDataRegionChangeTab("current");
		this.getSimInventoryFunc();
		this.getTooltipFunc();

		this.$root.$on("dataVolumeTrendByPeriodOpen", period => {
			this.graphChangeTab(period);
			this.getDataVolumeAverages();
		});

		this.$root.$on("topMetricsOpen", period => {
			this.getTopMetricsFunc(period);
		});

		this.$root.$on("dataVolumeTrendsByRegionOpen", period => {
			this.getDataRegionChangeTab(period);
		});

		this.$root.$on("simInventoryOpen", period => {
			this.getSimInventoryFunc();
		});
	},
	methods: {
		changeSessionTab(event) {
			this.getDataSessions(event);
		},

		changeVolumeTab(event) {
			this.getDataVolume(event);
		},

		changeAlertsTab(event) {
			this.getAlerts(event);
		},

		changeZeroSessionsTab(event) {
			this.getZeroSessions(event);
		},

		getDataSessions(period) {
			this.totalDataSessionValue = null;
			this.dataSessionFailedStatus = false;
			HomeDashboardService.getDataSessionStatistic("", period.toLowerCase()).then(res => {
				if (res !== "FAIL - API Request Failed." && res !== undefined) {
					if (res["Total Data Sessions"]) {
						this.currentDataSessionValue = res["Total Data Sessions"].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
						this.currentDataSessionPercent = res["Percentage Change"].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
					} else {
						this.currentDataSessionValue = res["Total Data Sessions"];
						this.currentDataSessionPercent = res["Percentage Change"];
					}
					this.totalDataSessionValue = this.currentDataSessionValue;
					this.totalDataSessionPercent = this.currentDataSessionPercent;
				} else {
					this.dataSessionFailedStatus = true;
				}
			});
		},

		getDataVolume(period) {
			this.totalDataVolumeValue = null;
			this.dataVolumeFailedStatus = false;
			HomeDashboardService.getDataVolumeStatistic("", period.toLowerCase()).then(res => {
				if (res !== "FAIL - API Request Failed." && res !== undefined) {
					this.currentDataVolumeValue = res["Total Data Volumes"];
					this.currentDataVolumePercent = res["Percentage Change"];
					this.totalDataVolumeValue = this.currentDataVolumeValue;
					this.totalDataVolumePercent = this.currentDataVolumePercent;
				} else {
					this.dataVolumeFailedStatus = true;
				}
			});
		},

		getAlerts(period) {
			this.totalAlertsValue = null;
			this.alertsFailedStatus = false;
			HomeDashboardService.getAlertsStatistic("", period.toLowerCase()).then(res => {
				//console.log('getAlertsStatistic:',res);
				if (res !== "FAIL - API Request Failed." && res !== undefined) {
					if (res["Total Alerts"]) {
						this.currentAlertsValue = res["Total Alerts"].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
						this.currentAlertsPercent = res["Percentage Change"].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
					} else {
						this.currentAlertsValue = res["Total Alerts"];
						this.currentAlertsPercent = res["Percentage Change"];
					}
					this.totalAlertsValue = this.currentAlertsValue;
					this.totalAlertsPercent = this.currentAlertsPercent;
				} else {
					this.alertsFailedStatus = true;
				}
			});
		},

		getZeroSessions(period) {
			this.totalZeroSessionValue = null;
			this.zeroSessionsFailedStatus = false;
			HomeDashboardService.getZeroSessionStatistic("", period.toLowerCase()).then(res => {
				if (res !== "FAIL - API Request Failed." && res !== undefined) {
					if (res["Total Zero Sessions"]) {
						this.currentZeroSessionValue = res["Total Zero Sessions"].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
						this.currentZeroSessionPercent = res["Percentage Change"].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
					} else {
						this.currentZeroSessionValue = res["Total Zero Sessions"];
						this.currentZeroSessionPercent = res["Percentage Change"];
					}
					this.totalZeroSessionValue = this.currentZeroSessionValue;
					this.totalZeroSessionPercent = this.currentZeroSessionPercent;
				} else {
					this.zeroSessionsFailedStatus = true;
				}
			});
		},

		graphChangeTab(event) {
			if (cardOpenStatusDirective.getOpenCardStatus()) {
				let cardStatus = cardOpenStatusDirective.getOpenCardStatus()["dataVolume-chart-collapse"];
				if (cardStatus) {
					HomeDashboardService.getDataVolumeTrendByPeriod(event.toLowerCase()).then(res => {
						//console.log('getDataVolumeTrendByPeriod:',res);
						let xLabel = [];
						let dataVolume = [];
						for (let item in res) {
							//console.log(res[item]);
							if (res[item]["Date"]) {
								xLabel.push(res[item]["Date"]);
								//console.log('date:',res[item]['Date']);
							}
							if (res[item]["Data Volume"]) {
								//console.log('datavol:',res[item]['Data Volume']);
								dataVolume.push(res[item]["Data Volume"].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
							}
						}
						this.chartXLabel = xLabel;
						this.chartDataVolume = dataVolume;

						//console.log('chartXLabel',xLabel);
						//console.log('chartDataVolume',dataVolume);

						this.$root.$emit("dataVolumeTrendByPeriod", xLabel, dataVolume);
						setTimeout(() => {
							this.$root.$emit("dataVolumeAverage", this.dataVolumeTrendsByPeriodData);
						}, 1000);
					});
				}
			}
		},

		getDataVolumeAverages() {
			if (cardOpenStatusDirective.getOpenCardStatus()) {
				let cardStatus = cardOpenStatusDirective.getOpenCardStatus()["dataVolume-chart-collapse"];
				if (cardStatus) {
					HomeDashboardService.getDataVolumeAverage().then(res => {
						let data = {
							yearlyV: res[0]["Data Volume this year (MB)"],
							yearlyP: res[0]["Year Percent Change"],
							monthlyV: res[0]["Data Volume this month (MB)"],
							monthlyP: res[0]["Month Percent Change"],
							dailyV: res[0]["Data Volume today (MB)"],
							dailyP: res[0]["Day Percent Change"],
						};
						this.dataVolumeTrendsByPeriodData = data;
						this.$root.$emit("dataVolumeAverage", data);
					});
				}
			}
		},

		getTopMetricsFunc(method) {
			if (cardOpenStatusDirective.getOpenCardStatus()) {
				let cardStatus = cardOpenStatusDirective.getOpenCardStatus()["topMetrics-collapse"];
				if (cardStatus) {
					method = method.replace(/ /g, "");
					if (method === "Alerts") {
						HomeDashboardService.getTopicMetricsAlerts(method).then(res => {
							this.$root.$emit("topMetrics", res);
						});
					} else {
						HomeDashboardService.getTopMetrics(method).then(res => {
							try {
								this.$root.$emit("topMetrics", res);
							} catch (e) {
								console.log("error in getTopMetricsFunc:", e);
							}
						});
					}
				}
			}
		},

		getDataRegionChangeTab(period) {
      try {
        if (cardOpenStatusDirective.getOpenCardStatus()) {
          let cardStatus = cardOpenStatusDirective.getOpenCardStatus()["dataVolume-map-collapse"];
          if (cardStatus) {
            HomeDashboardService.getVolumeByRegion(period.toLowerCase()).then(res => {
              //console.log('[DEBUG] EMIT dataVolumeTrendByRegion ')
              this.$root.$emit("dataVolumeTrendByRegion", res);
            });
          }
        }
      } catch (e) {
        debugger
        console.error(e);
      }
		},

		getSimInventoryFunc() {
			if (cardOpenStatusDirective.getOpenCardStatus()) {
				let cardStatus = cardOpenStatusDirective.getOpenCardStatus()["sim-inventory-collapse"];
				if (cardStatus) {
					HomeDashboardService.getSimInventory().then(res => {
						this.$root.$emit("simInventory", res);
					});
				}
			}
		},

		getTooltipFunc() {
			let tooltip = configDirective.getDashboardToolTip();
			if (tooltip) {
				this.dataSessionToolTip = tooltip["data_session_tooltip"];
				this.dataVolumeToolTip = tooltip["data_volume_tooltip"];
				this.alertsToolTip = tooltip["alerts_tooltip"];
				this.zeroSessionsToolTip = tooltip["zero_sessions_tooltip"];
				this.dataVolumeByPeriodToolTip = tooltip["data_volume_by_period_tooltip"];
				this.dataVolumeByRegionToolTip = tooltip["data_volume_by_region_tooltip"];
				this.topMetricsDataVolumeToolTip = tooltip["top_metrics_data_volume_tooltip"];
				this.watchDogAlertsToolTip = tooltip["watchdog_alerts_tooltip"];
				this.simInventoryToolTip = tooltip["sim_inventory_tooltip"];
			}
		},

		properCase(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
	},
};
</script>
